import { render } from "./ConfigImageUpload.vue?vue&type=template&id=07b32274&scoped=true"
import script from "./ConfigImageUpload.vue?vue&type=script&lang=js"
export * from "./ConfigImageUpload.vue?vue&type=script&lang=js"

import "./ConfigImageUpload.vue?vue&type=style&index=0&id=07b32274&scoped=true&lang=css"
import "./ConfigImageUpload.vue?vue&type=style&index=1&id=07b32274&lang=css"

import exportComponent from "D:\\newProjectGit\\HbzsbAdminClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07b32274"]])

export default __exports__